export enum SketchMode {
  Wireframe,
  Normal,
  Tangent,
  BiTangent
}
